import { WaitlistForm } from "./WaitlistForm";

export const FinalCTA = () => (
  <section id="contact" data-testid="final-cta-section" className="relative py-24 sm:py-32 lg:py-40 overflow-hidden">
    <div className="absolute inset-x-0 top-0 axt-hairline" />
    <div
      className="absolute -top-32 left-1/2 -translate-x-1/2 w-[70vw] max-w-[900px] h-[520px] pointer-events-none axt-breathe"
      style={{ background: "radial-gradient(closest-side, rgba(255,255,255,0.10), transparent 70%)", filter: "blur(20px)" }}
      aria-hidden="true"
    />
    <div className="relative max-w-6xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
      <div className="lg:col-span-5" data-reveal>
        <p className="axt-rule mb-5">
          <span>005 · Waitlist</span>
        </p>
        <h2 data-testid="final-cta-headline" className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-[-0.02em] text-[color:var(--axt-text)]">
          Join the waitlist.
        </h2>
        <p className="mt-6 text-base lg:text-lg leading-relaxed text-[color:var(--axt-text-dim)] max-w-md">
          Axtara is onboarding a limited number of funds in 2026. Leave your email and a senior fund accountant will reach out when your slot opens —
          with a live run of your capital call, fees, waterfall and LP pack.
        </p>
        <ul className="mt-8 space-y-3 text-sm text-[color:var(--axt-text-dim)]" data-testid="final-cta-points">
          {["Limited 2026 cohort, onboarded in order", "A live run on your data, not a demo video", "A senior CA/CPA on every call"].map((t) => (
            <li key={t} className="flex items-center gap-3">
              <span className="w-1.5 h-1.5 bg-[color:var(--axt-accent)]" style={{ boxShadow: "0 0 10px var(--axt-glow-strong)" }} />
              {t}
            </li>
          ))}
        </ul>
      </div>
      <div className="lg:col-span-7" data-reveal>
        <div className="axt-glass axt-noise p-6 sm:p-8 lg:p-10">
          <WaitlistForm source="final-cta" idPrefix="cta" />
        </div>
      </div>
    </div>
  </section>
);
